import _lib from '../_lib';
import {PdfNavigation,PdfsNavigation} from '@/store/modules/fsm/messages';
import { clearPdf } from '@/mutation-types';

import active from './active/index';

export default ({tree,parent,api}) => {
  let regionName = 'pdfs';
  let activations = [
    {
      name: 'pdf',
      test: api.messageIs(PdfNavigation)
    },
    {
      name: 'pdfs',
      test: api.messageIs(PdfsNavigation)
    },
  ];
  let activeIndex = active;
  let readyToDormant = ({context}) => context.commit(`login/pdf/${clearPdf}`,null,{root:true});
  let func = _lib({regionName,activations,activeIndex,readyToDormant});
  return func({tree,parent,api});
};
